import styled from '@emotion/styled';
import { Box, Button, Chip, Tab, Tabs } from '@mui/material';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import React from 'react';
import { useService } from './hooks';
import { useRaffleDrawContext } from './provider';

const TABS = [
  { label: "All Draws", value: "", icon: <GridViewOutlinedIcon fontSize="small" /> },
  { label: "Regular Players", value: "REGULAR", icon: <GroupOutlinedIcon fontSize="small" /> },
  { label: "VIP Players", value: "VIP", icon: <EmojiEventsOutlinedIcon fontSize="small" /> },
];

const BodyHeader = () => {
  const { tabCounts } = useService();
  const { state, onDispatch, openCreate } = useRaffleDrawContext();
  const { subject } = state;

  const counts = [tabCounts.all, tabCounts.regular, tabCounts.vip];

  const handleTabChange = (_: React.SyntheticEvent, newValue: string) => {
    onDispatch('subject')(newValue);
    onDispatch('page')(0);
  };

  return (
    <StyledWrapRow
      sx={{
        width: "100%",
        my: { xl: 0, lg: 0, md: 0, sm: "22px", xs: "22px" },
        height: { xl: 96, lg: 96, md: 96, sm: "auto", xs: "auto" },
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
      <Tabs
        value={subject}
        onChange={handleTabChange}
        TabIndicatorProps={{ style: { display: "none" } }}
        sx={{ minHeight: 44 }}
      >
        {TABS.map((tab, i) => (
          <Tab
            key={tab.value}
            value={tab.value}
            disableRipple
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {tab.icon}
                <span>{tab.label}</span>
                <Chip
                  label={counts[i]}
                  size="small"
                  sx={{
                    height: 20,
                    fontSize: 11,
                    fontWeight: 600,
                    bgcolor: subject === tab.value ? "#EDE8FF" : "#E8E8E8",
                    color: subject === tab.value ? "#6C2BD9" : "#888",
                    borderRadius: "5px",
                  }}
                />
              </Box>
            }
            sx={{
              textTransform: "none",
              fontWeight: 600,
              fontSize: 14,
              color: "#888",
              minHeight: 44,
              px: 2,
              borderRadius: "12px",
              border: "1px solid",
              backgroundColor: subject === tab.value ? "#FFFFFF" : "transparent",
              borderColor: subject === tab.value ? "#E5E7EF" : "transparent",
              boxShadow: subject === tab.value ? "0px 1px 4px rgba(0,0,0,0.12)" : "none",
              m: 1,
              "&.Mui-selected": { color: "#0F0F1A" },
            }}
          />
        ))}
      </Tabs>

      <StyledButtonCreate
        variant="text"
        disableRipple
        disableElevation
        sx={{
          color: "white",
          width: { xl: 210, lg: 210, md: 210, sm: "100%", xs: "100%" },
          height: { xl: 47, lg: 47, md: 47, sm: 54, xs: 54 },
          bgcolor: "purple.dark",
          "&:hover": { bgcolor: "purple.main" },
        }}
        onClick={openCreate}>
        CREATE NEW DRAW
      </StyledButtonCreate>
    </StyledWrapRow>
  );
}

const StyledWrapRow = styled(Box)(() => ({
  width: "100%",
  display: 'flex',
}));

const StyledButtonCreate = styled(Button)(({ theme }: any) => ({
  width: 192,
  marginRight: 0,
  display: 'flex',
  color: "white",
  borderRadius: 8,
  backgroundColor: theme.palette.purple.dark,
}));

export default React.memo(BodyHeader);
